export const COUNTRY_ISO_MAP:any={
    "Afghanistan": "af",
    "Albania": "al",
    "Algeria": "dz",
    "Andorra": "ad",
    "Angola": "ao",
    "Argentina": "ar",
    "Armenia": "am",
    "Australia": "au",
    "Austria": "at",
    "Azerbaijan": "az",
    "Bahamas": "bs",
    "Bahrain": "bh",
    "Bangladesh": "bd",
    "Belgium": "be",
    "Bhutan": "bt",
    "Bolivia": "bo",
    "Bosnia and Herzegovina": "ba",
    "Brazil": "br",
    "Bulgaria": "bg",
    "Cambodia": "kh",
    "Cameroon": "cm",
    "Canada": "ca",
    "Chile": "cl",
    "China": "cn",
    "Colombia": "co",
    "Costa Rica": "cr",
    "Croatia": "hr",
    "Cuba": "cu",
    "Cyprus": "cy",
    "Czech Republic": "cz",
    "Denmark": "dk",
    "Dominican Republic": "do",
    "Ecuador": "ec",
    "Egypt": "eg",
    "Estonia": "ee",
    "Ethiopia": "et",
    "Finland": "fi",
    "France": "fr",
    "Georgia": "ge",
    "Germany": "de",
    "Greece": "gr",
    "Guatemala": "gt",
    "Hong Kong": "hk",
    "Hungary": "hu",
    "Iceland": "is",
    "India": "in",
    "Indonesia": "id",
    "Iran": "ir",
    "Iraq": "iq",
    "Ireland": "ie",
    "Israel": "il",
    "Italy": "it",
    "Jamaica": "jm",
    "Japan": "jp",
    "Jordan": "jo",
    "Kazakhstan": "kz",
    "Kenya": "ke",
    "Kuwait": "kw",
    "Latvia": "lv",
    "Lebanon": "lb",
    "Lithuania": "lt",
    "Luxembourg": "lu",
    "Malaysia": "my",
    "Maldives": "mv",
    "Malta": "mt",
    "Mexico": "mx",
    "Moldova": "md",
    "Monaco": "mc",
    "Mongolia": "mn",
    "Montenegro": "me",
    "Morocco": "ma",
    "Myanmar": "mm",
    "Nepal": "np",
    "Netherlands": "nl",
    "New Zealand": "nz",
    "Nigeria": "ng",
    "North Korea": "kp",
    "Norway": "no",
    "Oman": "om",
    "Pakistan": "pk",
    "Panama": "pa",
    "Paraguay": "py",
    "Peru": "pe",
    "Philippines": "ph",
    "Poland": "pl",
    "Portugal": "pt",
    "Qatar": "qa",
    "Romania": "ro",
    "Russia": "ru",
    "Saudi Arabia": "sa",
    "Serbia": "rs",
    "Singapore": "sg",
    "Slovakia": "sk",
    "Slovenia": "si",
    "South Africa": "za",
    "South Korea": "kr",
    "Spain": "es",
    "Sri Lanka": "lk",
    "Sweden": "se",
    "Switzerland": "ch",
    "Taiwan": "tw",
    "Tanzania": "tz",
    "Thailand": "th",
    "Tunisia": "tn",
    "Turkey": "tr",
    "Ukraine": "ua",
    "United Arab Emirates": "ae",
    "United Kingdom": "gb",
    "United States": "us",
    "USA": "us",
    "Puerto Rico": "pr",
    "Uruguay": "uy",
    "Venezuela": "ve",
    "Vietnam": "vn",
    "UAE":"ae",
    "Macedonia":"mk",
    "Czechia":"cz",
    "North Macedonia":"mk",
    "Canary Islands": "es",
    // 3-letter ISO country codes
    "GBR": "gb",
    "ISL": "is",
    "CHE": "ch",
    "BRA": "br",
    "MYS": "my",
    "TUR": "tr",
    "EGY": "eg",
    "ARE": "ae",
    "SGP": "sg",
    "IDN": "id",
    "THA": "th",
    "ARG": "ar",
    "FRA": "fr",
    "PRI": "pr",
    "AUS": "au",
    "HUN": "hu",
    "QAT": "qa",
    "GTM": "gt",
    "BHR": "bh",
    "ITA": "it",
    "ZAF": "za",
    "MEX": "mx",
    "DOM": "do",
    "IRL": "ie",
    "TWN": "tw",
    "GUM": "gu",
    "COL": "co",
    "GRC": "gr",
    "CHN": "cn",
    "ESP": "es",
    "NZL": "nz",
    "DEU": "de",
    "PRT": "pt",
  }
  

  export const currencySymbolMap: any = {
    USD: "$",
    EUR: "€",
    GBP: "£",
    JPY: "¥",
    CNY: "¥",
    INR: "₹",
    KRW: "₩",
    RUB: "₽",
    TRY: "₺",
    BRL: "R$",
    MXN: "$",
    CAD: "C$",
    AUD: "A$",
    HKD: "HK$",
    SGD: "S$",
    CHF: "CHF",
    SEK: "kr",
    DKK: "kr",
    NOK: "kr",
    PLN: "zł",
    CZK: "Kč",
    HUF: "Ft",
    THB: "฿",
    PHP: "₱",
    VND: "₫",
    EGP: "£E",
    ILS: "₪",
    UAH: "₴",
    NGN: "₦"
  };
  
  